var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6061 5.01999L15.2791 0.691994C15.1622 0.581586 15.0074 0.520081 14.8466 0.520081C14.6858 0.520081 14.5311 0.581586 14.4141 0.691994L2.29611 12.81V12.815C2.24735 12.8658 2.20776 12.9247 2.17911 12.989C2.17111 13.005 2.16611 13.022 2.16011 13.039C2.15049 13.0605 2.14214 13.0825 2.13511 13.105L0.835114 18.731C0.814448 18.821 0.814402 18.9144 0.834979 19.0044C0.855557 19.0944 0.896225 19.1786 0.953938 19.2506C1.01165 19.3227 1.08491 19.3807 1.16824 19.4204C1.25157 19.4602 1.3428 19.4805 1.43511 19.48C1.48156 19.4797 1.52784 19.4743 1.57311 19.464L7.19911 18.164C7.21985 18.1574 7.24021 18.1498 7.26011 18.141C7.27811 18.135 7.29411 18.129 7.31111 18.122C7.37473 18.0948 7.43324 18.0569 7.48411 18.01H7.48911L17.0091 8.48999L19.6091 5.88999C19.6664 5.83289 19.7118 5.76498 19.7427 5.69021C19.7736 5.61543 19.7894 5.53527 19.7891 5.45437C19.7888 5.37346 19.7725 5.29341 19.7411 5.21885C19.7097 5.1443 19.6638 5.07671 19.6061 5.01999ZM18.3061 5.45299L16.5751 7.18399L14.8441 5.45299L13.1141 3.72099L14.8461 1.98999L18.3061 5.45299ZM12.2471 4.58699L13.5471 5.88699L4.89211 14.542L3.59211 13.242L12.2471 4.58699ZM7.05611 16.704L5.75611 15.404L14.4141 6.75099L15.7141 8.05099L7.05611 16.704ZM2.24711 18.052L3.07711 14.452L4.46011 15.835L5.84311 17.218L2.24711 18.052Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ba13656e9ad185afda53b77f7d63114f.svg";
export { ForwardRef as ReactComponent };